import React from 'react'
import '../Aboutus/Aboutus.css'
import Projects from './Projects'
import AboutMe from './Aboutme'
import About from '../About/About'
const Aboutus = () => {
  return (
    <>
    <AboutMe/>
<Projects/>
<About/>
    </>
  )
}

export default Aboutus